import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ImpresorasService} from "../../services/impresoras.service";
import {SecurityService} from "../../services/security.service";
import {Impresoras} from "../../models/Impresoras";
import {MatTableDataSource} from "@angular/material/table";
import {NotificationService} from "../../services/notification.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {
  FabFilterDescriptor,
  FabTableState,
  filterStateChange,
  process
} from "@fabric/components/table-filter/data-query";
import {
  FabDateFilterComponent,
  FabDateFilterOperator,
  FabNumberFilterComponent,
  FabStringFilterComponent
} from "@fabric/components/table-filter";
import {MatFormField} from "@angular/material/form-field";
import {ErrorCodes} from "../../constants/ErrorCodes";
import {catchError, concat, forkJoin, map, Observable, ObservableInput, of} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {UserFunctionCode} from "../../constants/UserFunctionCode";
import {PtoEmisionService} from "../../services/ptoEmision.service";

@Component({
  selector: 'app-impresora-maintenance',
  templateUrl: './impresora-maintenance.component.html',
  styleUrls: ['./impresora-maintenance.component.scss']
})
export class ImpresoraMaintenanceComponent implements OnInit {
  user: string;
  canAddOrEdit: boolean = false;

  isLoading: boolean = false;

  maxLote: number = 250;
  // Current Impresoras list
  impresoras: Impresoras[] = [];
  otdsImpresoraCode: string[] = [];

  // Mat table
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren('tableFilter') tableFilters: QueryList<FabStringFilterComponent | FabNumberFilterComponent | FabDateFilterComponent>;
  @ViewChild('impresoraCode') control: MatFormField;

  pageSizeOptions: number[] = [10, 15, 20, 25];
  pageSize: number = this.pageSizeOptions[0];
  resultsLength: number = 0;
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  numberOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  dataSource: MatTableDataSource<Impresoras>;
  displayedColumns: string[] = [
    "impresoraCode",
    "description",
    "distributionList",
    "lote",
    "estado",
    "fecCreacion",
    "usrCreacion",
    "fecModif",
    "usrModif",
    "edit"
  ];
  selector: string;

  constructor(private impresorasService: ImpresorasService,
              private ptoEmisionService: PtoEmisionService,
              private securityService: SecurityService,
              private notificationService: NotificationService,
              private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.user = this.securityService.LOGGED_USER.gmin;
    this.canAddOrEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
    this.fetchData();
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  fetchData() {
    this.isLoading = true;
    this.impresorasService.getAllImpresoras().subscribe({
      next: (res) => {
        // Only display active impresoras
        this.impresoras = res.filter(item => item.estado);

        // Store original data value to each item
        this.impresoras.forEach(item => item.originalData = JSON.parse(JSON.stringify(item)));

        this.dataSource = new MatTableDataSource<Impresoras>(this.impresoras);

        // Set sort and paginator after creating data source
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.resultsLength = this.impresoras.length;
      },
      error: (err: string) => {
        this.notificationService.open(err, 'error');
      },
      complete: () => {
        this.processData();
        this.isLoading = false;
      }
    });

    // Find vehicle otds impresora codes to make sure user can't make these impresoras inactive.
    this.ptoEmisionService.getAllPtoEmision().subscribe({
      next: (ptoEmisionList) => {
        ptoEmisionList.filter(pto => pto.descriptions.toLowerCase() === 'vehicle' && pto.codImpresora)
                      .forEach(vehPto => this.otdsImpresoraCode.push(vehPto.codImpresora));
      }
    })
  }

  filterChange(event: any) {
    this.state.skip = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.state.filter = filterStateChange(event, <FabFilterDescriptor[]>this.state.filter);
    this.processData();
  }

  // Process new data when table data changes
  processData() {
    this.dataSource.data = process(this.impresoras, this.state);
  }

  addRow() {
    let newRow = new Impresoras();
    // Default values for new impresora
    newRow.isAdd = true;
    newRow.estado = true;
    newRow.usrCreacion = this.user;

    this.impresoras.unshift(newRow);
    this.processData();
  }

  editRow(element: Impresoras) {
    element.isEdit = true;
    this.processData();
    // this.validateRow(element);
  }

  cancelRow(element: Impresoras) {
    // Revert data back to original data
    if (element.isEdit) {
      element.id = element.originalData.id;
      element.impresoraCode = element.originalData.impresoraCode;
      element.description = element.originalData.description;
      element.distributionList = element.originalData.distributionList;
      element.lote = element.originalData.lote;
      element.usrModif = element.originalData.usrModif;
      element.estado = element.originalData.estado;
      element.isEdit = false;
    }

    if (element.isAdd) {
      // Remove row from table in UI
      this.dataSource.data.splice(this.dataSource.data.indexOf(element), 1);
    }
    this.processData();
  }

  save() {
    let saveImpresoras: Impresoras[] = this.impresoras.filter(item => item.isEdit || item.isAdd);
    let addObservables: ObservableInput<any>[] = [];
    let editObservables: ObservableInput<any>[] = [];
    let errors: HttpErrorResponse[] = [];
    let saved = 0;
    if (this.validateAllRows()) {
      this.isLoading = true;
      saveImpresoras.forEach((row) => {
          // Clean email string before sending to DB
          row.distributionList = this.cleanString(row.distributionList);

          // Show usrModif if the isEdit row has been modified, else keep as null
          if (row.isEdit && this.modified(row)) {
            row.usrModif = this.user;
          }

          // Begin add or update process
          let observableType = row.estado ? addObservables : editObservables;
          observableType.push(this.impresorasService.addOrUpdate(row, row.isAdd).pipe(
            map((res) => {
              console.log("Response: ");
              console.log(row);
              console.log(res);
              row.originalData = res;
              row.isEdit = false;
              row.isAdd = false;
              row.id = res.id;
              row.fecModif = res.fecModif;
              saved++;
            }),
            catchError((err) => {
              console.log(err.error.errorMessage);
              errors.push(err);
              return of(null);
            })
          ))

        }
      )
      concat(forkJoin(editObservables), forkJoin(addObservables)).subscribe({
        next: () => {
          if (errors.length == 0) {
            this.notificationService.open(ErrorCodes.SAVED, 'success');
            this.sortTableById();
          } else {
            const errorCounts = errors.map(err => err.message).reduce((accumulator, value) => {
              // @ts-ignore
              return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            let errorMessage = `${saved} rows saved. ${errors.length} rows have errors:`
              .concat(...Object.entries(errorCounts).map(([msg, count]) => `\n${msg} (${count})`));
            this.notificationService.open(errorMessage, 'error');
          }
        },
        complete: () => {
          this.processData();
          this.isLoading = false;
        }
      })
    }
    // Input validation failed
    else {
      this.notificationService.open(ErrorCodes.INVALID_DATA, 'error');
    }
  }

  sortTableById() {
    this.impresoras.sort((a, b) => {
      // @ts-ignore
      return b.id - a.id;
    });
  }

  get saveDisabled() {
    return (this.impresoras.filter(element => (element.isEdit && this.modified(element)) ).length == 0
        && this.impresoras.filter(element => element.isAdd).length == 0)
        || !this.validateAllRows()
  }

  validateAllRows() {
    return this.impresoras.filter(element => element.isEdit || element.isAdd).every((row) => this.validateRow(row));
  }

  validateRow(row: Impresoras) {
    return /^[a-zA-Z\d\s]{0,15}$/.test(row.impresoraCode) && // Match letters, digits, white spaces max length 15
      this.isValidLote(row.lote) &&
      row.distributionList?.length > 0 &&
      this.validEmailList(row.distributionList) &&
      row.description?.length > 0 &&
      row.impresoraCode?.trim().length >= 2 &&
      !this.idExistsInTable(row);
  }

  idExistsInTable(row: Impresoras) {
    return this.impresoras.find(item => item != row && item.impresoraCode == row.impresoraCode && item.estado && row.estado);
  }

  isValidLote(lote: number) : boolean {
    return lote > 0 && lote <= this.maxLote;
  }

  validEmailList(emailListString: string) {
    // Email pattern matches @[letters&digits].[letters] or @[letters&digits].[letters].[countryCode]
    // Example: test@domain123.net, test@domain123.com.us
    const emailPattern: RegExp = /^(\s*[a-zA-Z0-9._%+-]+@(([a-zA-Z0-9+]+\.[a-zA-Z]+)(.[a-zA-Z]{2})?)(,\s*)?)$/;

    // Clean up string and array of emails and match each email with emailPattern
    let emailList: string[] = this.cleanString(emailListString).split(',');

    return emailList.every(email => {
      return emailPattern.test(email.trim());
    })
  }

  cleanString(emailListString: string): string {
    // Format string - Replace \n, \t, commas, whitespaces and make string of emails separate by commas
    let emails: string = emailListString.trim().replace(/[\t\n\s,;]+/g, ", ");
    if (emails.trim().endsWith(',')) {
      // Remove trailing comma
      emails = emails.substring(0, emails.length - 2);
    }
    return emails.trim();
  }

  onEmailListChange(row: Impresoras, control: MatFormField) {
    // Validate email input and show red line if invalid
    if (!this.validEmailList(row.distributionList)) {
      this.notificationService.open(ErrorCodes.INVALID_DATA, "warn");
      control._control.ngControl?.control?.setErrors({'invalid-email': true});
    }
  }

  checkId(row: Impresoras, control: MatFormField) {
    if (this.idExistsInTable(row)) {
      this.notificationService.open(ErrorCodes.DUPLICATE_IMPRESORA, "warn");
      control._control.ngControl?.control?.setErrors({'id-already-exists': true});
    }
  }

  checkLote(row: Impresoras, control: MatFormField) {
    if (!this.isValidLote(row.lote)) {
      this.notificationService.open(ErrorCodes.LOTE_EXCEED_LIMIT, "error");
      control._control.ngControl?.control?.setErrors({'invalid-lote': true});
    }
  }

  // Check dirty before save
  modified(row: Impresoras) {
    return (row.id != row.originalData.id ||
            row.impresoraCode != row.originalData.impresoraCode ||
            row.description != row.originalData.description ||
            row.distributionList != row.originalData.distributionList ||
            row.lote != row.originalData.lote ||
            row.estado != row.originalData.estado);
  }

  // Check dirty for UI
  isDirty(row: Impresoras, key: any) {
    // @ts-ignore
    return row.isEdit && row[key] != row.originalData[key];
  }

  isOtdsImpresora(impresora: Impresoras) {
    let currentRowImpresoraCode: string = impresora.impresoraCode;
    return this.otdsImpresoraCode.includes(currentRowImpresoraCode);
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.impresoras.find(item => item.isAdd || item.isEdit)) {
      return confirm("You have unsaved changes. Leave page anyway?");
    } else {
      return true;
    }
  }
}
